import React from 'react';
import { useI18n } from './i18n';

function Recovery({ onRetry }) {
  const { t } = useI18n();
  return <main className="app-error-recovery" role="alert">
    <h1>{t('recovery.title')}</h1>
    <p>{t('recovery.body')}</p>
    <div className="app-error-recovery__actions">
      <button type="button" className="primary-button" onClick={onRetry}>{t('recovery.retry')}</button>
      <button type="button" className="secondary-button" onClick={() => window.location.reload()}>{t('recovery.reload')}</button>
    </div>
  </main>;
}

function Recovered({ onReady }) {
  React.useEffect(() => { onReady(); }, [onReady]);
  return null;
}

export default class AppErrorBoundary extends React.Component {
  state = { failed: false, attempt: 0 };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error, info) {
    this.lastError = error;
    try {
      window.instantTranscriberDiagnostics?.reportRuntimeError('react_render_error', error, {
        componentStack: info?.componentStack, component: this.props.component,
      });
    } catch { /* Recovery also works when diagnostics are unavailable. */ }
  }
  retry = () => {
    this.recovering = true;
    this.setState(state => ({ failed: false, attempt: state.attempt + 1 }));
  };
  recovered = () => {
    if (!this.recovering || this.state.failed) return;
    this.recovering = false;
    try { window.instantTranscriberDiagnostics?.reportRuntimeRecovery?.(this.lastError, { component: this.props.component }); }
    catch { /* Analytics cannot prevent a successful UI recovery. */ }
  };
  render() {
    return this.state.failed ? <Recovery onRetry={this.retry} />
      : <React.Fragment key={this.state.attempt}>{this.props.children}<Recovered onReady={this.recovered} /></React.Fragment>;
  }
}
